import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_PPDAY_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_PPDAY_80_N,
  },
  {
    pageId: PageId.CHAT_UPSELL_PPDAY_80,
  },
  {
    pageId: PageId.UPSELL_PPDAY_80,
  },
  {
    pageId: PageId.DOWNLOAD_PPDAY_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
